import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['link'];

  connect() {
    this.linkTargets.forEach(link => {
      $(link).on('ajax:beforeSend', () => this.startLoading(link));
    });

    $(document).on('ajax:complete.spinner ajax:error.spinner', () => {
      this.stopAllSpinners();
    });
  }

  disconnect() {
    this.linkTargets.forEach(link => {
      $(link).off('ajax:beforeSend');
    });

    $(document).off('ajax:complete.spinner ajax:error.spinner');
  }

  startLoading(linkOrEvent) {
    const link = linkOrEvent.currentTarget || linkOrEvent;
    if (!link) return;

    let spinner = link.previousElementSibling;
    if (!spinner?.classList.contains('js-loading-spinner')) {
      spinner = this.createSpinner();
      link.insertAdjacentElement('beforebegin', spinner);
    }

    requestAnimationFrame(() => {
      spinner.classList.remove('tw-opacity-0', 'tw-translate-x-2');
      spinner.classList.add('tw-opacity-100', 'tw-translate-x-0');
    });

    link.setAttribute('aria-busy', 'true');
    link.classList.add('tw-pointer-events-none', 'tw-opacity-70');
  }

  stopLoading(event) {
    const link = event.currentTarget;
    if (!link) return;

    const spinner = link.previousElementSibling;
    if (!spinner?.classList.contains('js-loading-spinner')) return;

    this.removeSpinner(spinner);
    this.enableLink(link);
  }

  stopAllSpinners() {
    document.querySelectorAll('.js-loading-spinner').forEach(spinner => {
      this.removeSpinner(spinner);
    });

    document.querySelectorAll('a[aria-busy="true"]').forEach(link => {
      this.enableLink(link);
    });
  }

  createSpinner() {
    const spinner = document.createElement('span');
    spinner.className = 'js-loading-spinner tw-inline-flex tw-items-center tw-justify-center tw-h-4 tw-w-4 tw-transform tw-transition-all tw-duration-300 tw-ease-out tw-opacity-0 tw-translate-x-2';
    spinner.setAttribute('aria-hidden', 'true');
    spinner.innerHTML = `
      <svg class="tw-h-4 tw-w-4 tw-animate-spin tw-text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="tw-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="tw-opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
    `;
    return spinner;
  }

  removeSpinner(spinner) {
    spinner.classList.remove('tw-opacity-100', 'tw-translate-x-0');
    spinner.classList.add('tw-opacity-0', 'tw-translate-x-2');
    spinner.addEventListener('transitionend', () => {
      spinner.remove();
    }, { once: true });
  }

  enableLink(link) {
    link.removeAttribute('aria-busy');
    link.classList.remove('tw-pointer-events-none', 'tw-opacity-70');
  }
}
